import React from 'react';
import { Provider } from 'react-redux';
import dayjs from 'dayjs';
import CoursePage from '../page/CoursePage';
import store from '../configureStore';
import * as frameActions from '../actions/frames';
import * as settingsActions from '../actions/settings';
import ComponentWidgetContainer from './ComponentWidgetContainer';

export default class CourseWidgetContainer extends ComponentWidgetContainer {
  constructor(props) {
    super(props);

    const { exceededBookingsLimit, exceededTrialPlan } = props;

    if (!exceededBookingsLimit && !exceededTrialPlan) {
      this.loadFrames(this.location);
    }

    this.loadFrames = this.loadFrames.bind(this);
  }

  loadFrames(location) {
    const { product, settings } = this.props;
    const maxNumberOfMonths = parseInt(settings.setting.max_number_of_months, 10);
    let availableDates = 270; // default 9 months

    if (settings.setting && settings.setting.max_number_of_months && maxNumberOfMonths) {
      availableDates = 30 * maxNumberOfMonths;
    }

    const params = product.terms.filter((term) => dayjs(term.start_date) >= dayjs()).map((term) => {
      const startDate = dayjs(term.start_date).startOf('day');
      const finishDate = dayjs(term.finish_date);
      const availableDate = dayjs(term.start_date).add(availableDates, 'days');
      let date = finishDate <= availableDate ? finishDate : availableDate;

      if (startDate.isSame(date, 'date')) {
        date = dayjs(term.start_date).add(1, 'days');
      }

      return {
        termId: term.id,
        start: startDate,
        finish: date,
      };
    });

    store.dispatch(frameActions.fetchCourseFrames(params, location?.id));
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <CoursePage {...this.props} onLoadFrames={this.loadFrames} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting({ key, value }));
